export default "__VITE_PUBLIC_ASSET__ddda4e47__"